export default __webpack_public_path__ + "static/media/busanstreet.3d7af1cb.JPG";